<template>
  <div id="app">
    <Header v-show="!!!$store.state.ctrlHeaderHide"></Header>
    <router-view :style="viewStyle" @offScroll="setHeaderHide"/>
  </div>
</template>

<script>
import posImg from './assets/3pos.png'
import Header from "@/components/header/header";

export default {
  name: 'App',
  components: {
    Header,
  },
  data() {
    return {
      viewStyle: { 'height': '100%' }
    }
  },
  metaInfo: {
    title: "盈趣科技招聘",
    meta: [
      { name: "keywords", content: "盈趣科技招聘" },
      { name: "description", content: "www.intretech.com/campus/index.html#/" },

      { name: "twitter:card", content: "summary" },
      { name: "twitter:site", content: "http://www.intretech.com/campus/index.html#/" },
      { name: "twitter:title", content: "盈趣科技招聘" },
      { name: "twitter:description", content: "www.intretech.com/campus/index.html#/" },
      { name: "twitter:creator", content: "intretech" },
      { name: "twitter:image", content: posImg },

      { name: "og:title", content: "盈趣科技招聘" },
      { name: "og:type", content: "article" },
      { name: "og:url", content: "http://www.intretech.com/campus/index.html#/" },
      { name: "og:description", content: "www.intretech.com/campus/index.html#/" },
      { name: "og:site_name", content: "盈趣科技招聘" },
      { name: "og:image", content: posImg },
      { name: "fb:admins", content: "intretech" },
    ],
  },
  mounted() {
    /* <!-- 分享设置 -->
    <meta name="twitter:card" content="summary" />
    <meta name="twitter:site" content="http://www.intretech.com/campus/index.html#/">
    <meta name="twitter:title" content="盈趣科技招聘">
    <meta name="twitter:description" content="www.intretech.com/campus/index.html#/" />
    <meta name="twitter:creator" content="intretech" />
    <meta name="twitter:image" content="./static/3pos.png" />

    <!-- 分享设置 -->
    <meta property="og:title" content="盈趣科技招聘" />
    <meta property="og:type" content="article" />
    <meta property="og:url" content="http://www.intretech.com/campus/index.html#/" />
    <meta property="og:image" content="./static/3pos.png" />
    <meta property="og:description" content="www.intretech.com/campus/index.html#/" />
    <meta property="og:site_name" content="盈趣科技招聘" />
    <meta property="fb:admins" content="intretech" /> */
    this.$store.state.ctrlHeaderHide = true;
  },
  methods: {
    setHeaderHide(isHide) {
      let curHide = this.$store.state.ctrlHeaderHide;
      if(curHide === isHide) return;
      if(isHide) {
        this.$store.state.ctrlHeaderHide = true
        this.viewStyle = { 'height': '100%' }
      } else {
        this.$store.state.ctrlHeaderHide = false
        this.viewStyle = { 'height': 'calc(100% - 7vh)' }
      }
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.$store.state.activeTopTab = parseInt(val.query.tab);
        if(val.name === 'schoolPost' || val.name === 'schoolPosts' || val.name === 'aboutYq' || val.name === 'detail') {
          this.setHeaderHide(false);
          return;
        }
        this.setHeaderHide(true);
      }
    }
  }
}
</script>

<style>

  body, html {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    font-family: 'PingFang SC', 'Microsoft YaHei', Arial, 'Helvetica Neue', 'SimSun';
  }
  #app {
    font-family: 'PingFang SC', 'Microsoft YaHei', Arial, 'Helvetica Neue', 'SimSun';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    margin: 0;
    padding: 0;
    background: #fff;
    font-size: 14px;
    width: 100%;
    height: 100%;
    /* border: 1px solid black; */
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue